import React from "react";
import {
    CheckCircle as CheckCircleIcon,
    RadioButtonUnchecked as NotStartedIcon,
    PauseCircle as OnHoldIcon,
    PlayCircle as InProgressIcon,
} from "@mui/icons-material";

export const STATUS_CONFIG = {
    not_started: {
        label: "Not Started",
        color: "default",
        icon: <NotStartedIcon fontSize="small" />,
    },
    in_progress: {
        label: "In Progress",
        color: "primary",
        icon: <InProgressIcon fontSize="small" />,
    },
    on_hold: {
        label: "On Hold",
        color: "warning",
        icon: <OnHoldIcon fontSize="small" />,
    },
    complete: {
        label: "Complete",
        color: "success",
        icon: <CheckCircleIcon fontSize="small" />,
    },
};

export const PRIORITY_CONFIG = {
    1: { label: "Low", color: "#78909C" },
    2: { label: "Medium", color: "#42A5F5" },
    3: { label: "High", color: "#FF7043" },
    4: { label: "Urgent", color: "#E53935" },
};

export function formatDate(dateStr) {
    if (!dateStr) return "—";
    const d = new Date(dateStr + "T00:00:00");
    return d.toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
        year: "numeric",
    });
}

export function isOverdue(dateStr, status) {
    if (!dateStr || status === "complete") return false;
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return new Date(dateStr + "T00:00:00") < today;
}
